import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui'

export const useCarrierProfileCardRowStyles = makeStyles(theme => ({
  row: {
    paddingTop: theme.spacing(2),
  },
  borderBottom: {
    borderBottom: `1px solid ${brandColors.coolGray2}`,
    paddingBottom: theme.spacing(2),
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    flex: 2,

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  item: {
    flexBasis: 0,
    marginRight: '10px',
  },
  buttonWrapper: {
    flex: '0 0 auto',
    textAlign: 'right',
  },
}))
